import { render, staticRenderFns } from "./TheCarousel.vue?vue&type=template&id=7819894d&scoped=true&"
import script from "./TheCarousel.vue?vue&type=script&lang=js&"
export * from "./TheCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TheCarousel.vue?vue&type=style&index=0&id=7819894d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819894d",
  null
  
)

export default component.exports